/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1PersonIdStudentDataMutationRequest,
  PutApiV1PersonIdStudentDataMutationResponse,
  PutApiV1PersonIdStudentDataPathParams,
  PutApiV1PersonIdStudentData400,
  PutApiV1PersonIdStudentData401,
  PutApiV1PersonIdStudentData404,
  PutApiV1PersonIdStudentData500,
} from "../../types/personStudentController/PutApiV1PersonIdStudentData.ts";

function getPutApiV1PersonIdStudentDataUrl(
  id: PutApiV1PersonIdStudentDataPathParams["id"],
) {
  const res = {
    method: "PUT",
    url: `/api/v1/person/${id}/student-data` as const,
  };
  return res;
}

/**
 * @description Atualiza parcialmente a aba Student. Cria o vínculo de Student caso ainda não exista. Campos Ra e CodeUsp preservam o valor atual quando não informados (null-skip); demais campos sobrescrevem. **(Requer Authorization para autenticação)**
 * @summary Atualizar dados de aluno (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/student-data}
 */
export async function putApiV1PersonIdStudentData(
  id: PutApiV1PersonIdStudentDataPathParams["id"],
  data?: PutApiV1PersonIdStudentDataMutationRequest,
  config: Partial<RequestConfig<PutApiV1PersonIdStudentDataMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1PersonIdStudentDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdStudentData400
      | PutApiV1PersonIdStudentData401
      | PutApiV1PersonIdStudentData404
      | PutApiV1PersonIdStudentData500
    >,
    PutApiV1PersonIdStudentDataMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1PersonIdStudentDataUrl(id).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
